import { render, staticRenderFns } from "./YzNeedDrafts.vue?vue&type=template&id=8fa79658&scoped=true"
import script from "./YzNeedDrafts.vue?vue&type=script&lang=js"
export * from "./YzNeedDrafts.vue?vue&type=script&lang=js"
import style0 from "./YzNeedDrafts.vue?vue&type=style&index=0&id=8fa79658&prod&lang=css"
import style1 from "./YzNeedDrafts.vue?vue&type=style&index=1&id=8fa79658&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa79658",
  null
  
)

export default component.exports